import PocketBase from "pocketbase";
import { pocketBase } from 'config';

export const pb = new PocketBase(pocketBase.url);
